import React, { useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import GuardifyLogo from "../../assets/Guardify_Logo_Landscape_light.png";

interface ExportHeaderProps {
  stateOrOrganization: string;
  organization: string;
  useVerbiage: "state" | "organization" | "nationwide";
  isViewPage?: boolean;
}

const ExportHeader: React.FC<ExportHeaderProps> = ({
  stateOrOrganization,
  organization,
  useVerbiage,
  isViewPage = false,
}) => {
  const getVerbiage = () => {
    if (useVerbiage === "state") {
      return `Impact for ${stateOrOrganization}`;
    } else if (useVerbiage === "organization") {
      return `Impact for ${organization}`;
    } else {
      return "Nationwide Impact";
    }
  };

  const getDate = () => {
    const date = new Date();
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <Paper
      sx={{
        ml: { xs: 0, md: -3.5, sm: -3.5 },
        mt: -1,
        width: "1245px",
        height: "75px",
        background: "linear-gradient(to right, #572a76, #8a4b9c)",
        backdropFilter: "blur(10px)",
        boxShadow:
          "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        borderRadius: 0,
        fontFamily: "Lato",
      }}
    >
      <Box
        sx={{
          height: "75px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 2,
          ml: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "75px",
          }}
        >
          <img
            src={GuardifyLogo}
            alt="Guardify Logo"
            style={{ width: "200px", height: "auto", marginRight: 16 }}
          />
          <Typography
            variant="h4"
            component="h1"
            sx={{
              color: "white",
              fontWeight: 300,
              pr: 2,
              height: "75px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            |
          </Typography>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              color: "white",
              fontWeight: 300,
              height: "75px",
              width: 750,
              marginTop: "22px",
              marginBottom: "auto",
              overflow: "hidden",
              textWrap: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {getVerbiage().toUpperCase()}
          </Typography>
        </Box>
        <Box sx={{ position: "absolute", right: 38 }}>
          <Typography
            variant="h5"
            component="h1"
            sx={{ color: "white", fontWeight: 300 }}
          >
            {getDate()}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ExportHeader;
